/** px */
export const AI_ASSISTANT_PANEL_WIDTH = { initial: 440, min: 360, max: 720, step: 24 } as const;

export const clampAiAssistantPanelWidth = (width: number) =>
  Math.min(AI_ASSISTANT_PANEL_WIDTH.max, Math.max(AI_ASSISTANT_PANEL_WIDTH.min, Math.round(width)));
